/* eslint-disable no-nested-ternary */
import React from 'react'
import Layout from '../Layout'
import StatisticsComponent from './StatisticsComponent'

const StatisticsContainerComponent = () => {
  return (
    <Layout title="Statistics" hideBg fullBody>
      <StatisticsComponent showTimeFilter />
    </Layout>
  )
}

export default StatisticsContainerComponent
